export const buildPostMagicLinkUrl = ({
    pathname,
    search,
    hash,
}: {
    pathname: string;
    search: string;
    hash: string;
}) => {
    const searchParams = new URLSearchParams(search);
    searchParams.delete('magic_link_token');
    searchParams.delete('username');
    const nextSearch = searchParams.toString();
    return `${pathname}${nextSearch ? `?${nextSearch}` : ''}${hash}`;
};
